import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';

class ApplicationImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSource: '',
      imageUrl: this.props.url,
    };
  }

  fetchImage() {
    const { token } = this.props.token;
    var headers = new Headers({
      Authorization: `${token.token_type} ${token.access_token}`,
    });

    var options = {
      method: 'GET',
      headers: headers,
      mode: 'cors',
      cache: 'default',
    };

    var request = new Request(this.state.imageUrl);

    fetch(request, options).then((response) => {

      let getAttribute = response.headers.get('content-disposition')? response.headers.get('content-disposition').split('filename=')[1].split(".")[1]
      :response.headers.get('content-type') ? response.headers.get('content-type').split('/')[1] :'png';

      response.arrayBuffer().then((buffer) => {

        var base64Flag = 'data:image/'+getAttribute+';base64,';
        var imageStr = arrayBufferToBase64(buffer);
        let imageSrc = base64Flag + imageStr;
        this.setState({ imageSource: imageSrc });
      });
    });

    function arrayBufferToBase64(buffer) {
      var binary = '';
      var bytes = [].slice.call(new Uint8Array(buffer));

      bytes.forEach((b) => (binary += String.fromCharCode(b)));

      return window.btoa(binary);
    }
  }

  componentDidMount() {
    this.fetchImage();
  }

  render() {
    return (
      <div className="Image">
        <Image
          src={this.state.imageSource}
          size={this.props.size}
          onError={this.props.onError}
        />
      </div>
    );
  }
}

ApplicationImage.propTypes = {
  url: PropTypes.string.isRequired,
  token: PropTypes.object,
};

const mapStateToProps = (state) => ({
  token: state.api.account,
});

export default connect(mapStateToProps, null)(ApplicationImage);
